export default __webpack_public_path__ + "static/Hamlet-3520a7bd89e93f2ce4b27ec1302ca4b6.webp";